<template>
  <div class="cg-form-view">
    <div class="cg-form-header">
      <button type="button" class="cg-btn-back" @click="tornaSlot">
        Torna al calendario
      </button>
      <div v-if="store.selectedSlot" class="cg-slot-box">
        <div class="cg-slot-box-row">
          <span class="cg-slot-box-label">Data prenotazione</span>
          <span class="cg-slot-box-value">{{ store.selectedSlot.data }}</span>
        </div>
        <div class="cg-slot-box-row">
          <span class="cg-slot-box-label">Ora prenotazione</span>
          <span class="cg-slot-box-value">{{ store.selectedSlot.ora }}</span>
        </div>
      </div>
    </div>

    <h2 class="cg-title">Prenota</h2>

    <form class="cg-form" @submit.prevent="invia">
      <div class="cg-form-grid">
        <div class="cg-field">
          <label class="cg-label">Nome <span class="cg-required">*</span></label>
          <input
            v-model="form.nome"
            type="text"
            class="cg-input"
            :class="{ 'cg-input-error': errors.nome }"
            required
          />
          <span v-if="errors.nome" class="cg-error-label">Campo obbligatorio</span>
        </div>
        <div class="cg-field">
          <label class="cg-label">Cognome <span class="cg-required">*</span></label>
          <input
            v-model="form.cognome"
            type="text"
            class="cg-input"
            :class="{ 'cg-input-error': errors.cognome }"
            required
          />
          <span v-if="errors.cognome" class="cg-error-label">Campo obbligatorio</span>
        </div>
        <div class="cg-field">
          <label class="cg-label">Cellulare <span class="cg-required">*</span></label>
          <input
            v-model="form.cellulare"
            type="tel"
            class="cg-input"
            :class="{ 'cg-input-error': errors.cellulare }"
            required
          />
          <span v-if="errors.cellulare" class="cg-error-label">Campo obbligatorio</span>
        </div>
        <div class="cg-field">
          <label class="cg-label">Email <span class="cg-required">*</span></label>
          <input
            v-model="form.email"
            type="email"
            class="cg-input"
            :class="{ 'cg-input-error': errors.email }"
            required
          />
          <span v-if="errors.email" class="cg-error-label">{{ errors.email }}</span>
        </div>
        <div class="cg-field">
          <label class="cg-label">Targa <span class="cg-required">*</span></label>
          <input
            v-model="form.targa"
            type="text"
            class="cg-input"
            :class="{ 'cg-input-error': errors.targa }"
            required
          />
          <span v-if="errors.targa" class="cg-error-label">Campo obbligatorio</span>
        </div>
        <div v-if="serviziOptions.length" class="cg-field">
          <label class="cg-label">Servizio <span class="cg-required">*</span></label>
          <select
            v-model.number="form.servizio_cid"
            class="cg-input"
            :class="{ 'cg-input-error': errors.servizio }"
          >
            <option :value="0">Seleziona un servizio</option>
            <option v-for="s in serviziOptions" :key="s.servizio_cid?.id || s.id" :value="s.servizio_cid?.id ?? s.servizio_cid ?? 0">
              {{ s.servizio_cid?.descrizione || s.descrizione || '' }}
            </option>
          </select>
          <span v-if="errors.servizio" class="cg-error-label">Campo obbligatorio</span>
        </div>
        <div v-if="cerchiOptions.length" class="cg-field">
          <label class="cg-label">Cerchi</label>
          <select v-model="form.cerchi" class="cg-input">
            <option v-for="c in cerchiOptions" :key="String(c.value)" :value="c.value">
              {{ c.label }}
            </option>
          </select>
        </div>
        <div class="cg-field">
          <label class="cg-label">Coupon</label>
          <input v-model="form.coupon" type="text" class="cg-input" />
        </div>
      </div>

      <div class="cg-form-footer">
        <p class="cg-required-note"><span class="cg-required">*</span> Campi obbligatori</p>
        <p class="cg-privacy">Acconsentendo invii i dati secondo la nostra <a href="https://www.cambiogomme-online.it/privacy" target="_blank" rel="noopener">Privacy</a>.</p>

        <div class="cg-newsletter">
          <span class="cg-label">Newsletter <span class="cg-required">*</span></span>
          <div class="cg-radio-group">
            <label class="cg-radio-label">
              <input v-model="form.newsletter" type="radio" value="S" class="cg-radio" />
              Acconsento
            </label>
            <label class="cg-radio-label">
              <input v-model="form.newsletter" type="radio" value="N" class="cg-radio" />
              Non acconsento
            </label>
          </div>
          <span v-if="errors.newsletter" class="cg-error-label">Seleziona un'opzione</span>
        </div>
      </div>

      <div v-if="store.error" class="cg-error-msg">{{ store.error }}</div>
      <div class="cg-actions">
        <button type="submit" class="cg-btn-submit" :disabled="store.loading">
          {{ store.loading ? 'Invio...' : 'Prenota' }}
        </button>
      </div>
    </form>
  </div>
</template>

<script setup>
import { reactive, computed } from 'vue'

const props = defineProps({
  store: { type: Object, required: true },
  api: { type: Object, required: true },
})

const form = reactive({
  nome: '',
  cognome: '',
  cellulare: '',
  email: '',
  targa: '',
  servizio_cid: 0,
  cerchi: '',
  coupon: '',
  newsletter: '',
})

const errors = reactive({
  nome: false,
  cognome: false,
  cellulare: false,
  email: false,
  targa: false,
  servizio: false,
  newsletter: false,
})

const serviziOptions = computed(() => {
  const s = props.store.gommista?.servizi || []
  return Array.isArray(s) ? s : []
})
const cerchiOptions = computed(() => {
  const c = props.store.gommista?.cerchi
  if (!Array.isArray(c) || c.length === 0) return []
  // Formato API: array di [chiave, label], es. [ ['', 'Nessuna scelta'], ['13', '13'], ... ]
  const first = c[0]
  if (Array.isArray(first) && first.length >= 2) {
    return c.map((x) => ({ value: x[0], label: x[1] }))
  }
  // Fallback: oggetti con value/label o id/nome
  return c.map((x) => ({ value: x.value ?? x.id ?? x[0], label: x.label ?? x.nome ?? x.descrizione ?? x[1] }))
})

function clearErrors() {
  Object.keys(errors).forEach((k) => { errors[k] = false })
  errors.email = ''
}

function validate() {
  clearErrors()
  let ok = true
  if (!form.nome.trim()) { errors.nome = true; ok = false }
  if (!form.cognome.trim()) { errors.cognome = true; ok = false }
  if (!form.cellulare.trim()) { errors.cellulare = true; ok = false }
  if (!form.targa.trim()) { errors.targa = true; ok = false }
  if (!form.email.trim()) {
    errors.email = 'Campo obbligatorio'
    ok = false
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
    errors.email = 'Email non valida'
    ok = false
  }
  if (serviziOptions.value.length && !form.servizio_cid) { errors.servizio = true; ok = false }
  if (form.newsletter !== 'S' && form.newsletter !== 'N') { errors.newsletter = true; ok = false }
  return ok
}

function tornaSlot() {
  props.store.step = 'slot'
}

async function invia() {
  if (!validate()) return
  props.store.loading = true
  props.store.error = null
  const codGest = props.store.gommista?.codice_gestionale ?? props.store.gommista?.cod_gest
  const payload = {
    nome: form.nome,
    cognome: form.cognome,
    cellulare: form.cellulare,
    email: form.email,
    targa: form.targa,
    gommista_cod_gest: codGest,
    data_inizio: props.store.selectedSlot?.data,
    ora_inizio: props.store.selectedSlot?.ora || '',
    servizio_cid: form.servizio_cid || 0,
    cerchi: form.cerchi || '',
    coupon: form.coupon || '',
    newsletter: form.newsletter || 'N',
  }
  try {
    await props.api.inviaPrenotazione(payload)
    props.store.step = 'landing'
  } catch (e) {
    props.store.error = e.message || 'Errore invio prenotazione'
  } finally {
    props.store.loading = false
  }
}
</script>

<style scoped>
.cg-form-view {
  padding: 1rem 0;
  font-family: system-ui, -apple-system, sans-serif;
}

.cg-form-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #d1d5db;
  margin-bottom: 1rem;
}

.cg-btn-back {
  padding: 0.5rem 1.5rem;
  font-size: 1rem;
  color: #fff;
  background: #ca8a04;
  border: 1px solid #ca8a04;
  cursor: pointer;
}

.cg-btn-back:hover {
  background: #facc15;
  border-color: #facc15;
}

.cg-slot-box {
  padding: 0.75rem 1.5rem;
  background: #e5e7eb;
  border: 1px solid #d1d5db;
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1);
}

.cg-slot-box-row {
  margin-bottom: 0.25rem;
}

.cg-slot-box-row:last-child {
  margin-bottom: 0;
}

.cg-slot-box-label {
  font-size: 0.75rem;
  font-weight: 500;
  color: #ca8a04;
  text-transform: uppercase;
  margin-right: 0.25rem;
}

.cg-slot-box-value {
  font-size: 1.25rem;
  font-weight: 500;
  color: #111827;
}

.cg-title {
  font-size: 1.25rem;
  margin: 0 0 1rem 0;
  font-weight: 700;
  color: #111827;
}

.cg-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.cg-form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem 1.5rem;
}

@media (max-width: 520px) {
  .cg-form-grid {
    grid-template-columns: 1fr;
  }
}

.cg-field {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.cg-label {
  font-size: 0.875rem;
  color: #374151;
}

.cg-required {
  color: #ca8a04;
}

.cg-input {
  padding: 0.5rem 0.75rem;
  margin-top: 0.25rem;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 1rem;
  width: 100%;
  box-sizing: border-box;
}

.cg-input:focus {
  outline: none;
  border-color: #ca8a04;
}

.cg-input-error {
  border-color: rgb(217, 119, 6);
  background: #fdd;
}

.cg-input-error:focus {
  outline-color: rgb(217, 119, 6);
}

.cg-error-label {
  font-size: 0.875rem;
  color: rgb(217, 119, 6);
}

.cg-form-footer {
  padding-top: 1rem;
  border-top: 1px solid #d1d5db;
}

.cg-required-note {
  font-size: 0.75rem;
  color: #6b7280;
  margin: 0 0 0.5rem 0;
}

.cg-privacy {
  font-size: 0.875rem;
  color: #374151;
  margin: 0 0 1rem 0;
}

.cg-privacy a {
  color: #ca8a04;
}

.cg-newsletter {
  margin-bottom: 0.5rem;
}

.cg-radio-group {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem 2rem;
  margin-top: 0.5rem;
}

.cg-radio-label {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 500;
  cursor: pointer;
}

.cg-radio {
  accent-color: #ca8a04;
  width: 1rem;
  height: 1rem;
}

.cg-error-msg {
  padding: 0.5rem 0.75rem;
  background: #fef2f2;
  color: #b91c1c;
  border-radius: 4px;
  font-size: 0.875rem;
}

.cg-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.5rem;
}

.cg-btn-submit {
  padding: 0.5rem 2rem;
  margin: 1rem 0 0 0;
  font-size: 1.25rem;
  font-weight: 500;
  text-transform: uppercase;
  color: #fff;
  background: #ca8a04;
  border: 1px solid #ca8a04;
  cursor: pointer;
}

.cg-btn-submit:hover:not(:disabled) {
  background: #facc15;
  border-color: #facc15;
}

.cg-btn-submit:focus {
  outline: none;
  border-color: #facc15;
  background: #facc15;
}

.cg-btn-submit:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
</style>
